<template>
	<div class="p-grid kyc-data data-table data-table-list">
		<loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
		<div class="p-col-12">
			<div class="card card-w-title">
				<DataTable :value="dataTableKyc" class="p-datatable-responsive" :selection.sync="dataTableSelectedKyc" dataKey="kyc_id" :paginator="true" :rows="10" :filters="filters" :autoLayout="true">
					<template #header>
						<h2>List of applicants</h2>
						<div class="search">
							<span class="icon icon-search"></span>
							<InputText class="search-input p-filter" type="text" v-model="filters['name']" placeholder="Search" />
						</div>
					</template>
					<Column field="name" header="Name" :sortable="true" filterMatchMode="contains">
							<template #body="slotProps" class="name">
									<span class="name">{{ slotProps.data.name }}</span>
									<span class="email">{{ slotProps.data.email }}</span>
							</template>
					</Column>
					<Column field="date_of_birth" header="Date of birth" :sortable="true">
						<template #body="slotProps">
								{{ formatDate(slotProps.data.date_of_birth, false) }}
						</template>
					</Column>
					<Column headerStyle="min-width: 220px" field="address" header="Address" :sortable="true">
							<template #body="slotProps">
									<span class="address">{{ slotProps.data.address }}</span>
									<span class="address extra">{{ slotProps.data.zip }} {{ slotProps.data.city }} {{ slotProps.data.country }}</span>
							</template>
					</Column>
					<Column headerStyle="min-width: 30px" field="type" header="Type" :sortable="true">
							<template #body="slotProps">
									{{ toUpperCase(slotProps.data.type) }}
							</template>
					</Column>
					<Column field="status" header="Status" :sortable="true">
							<template #body="slotProps">
									{{ toUpperCase(slotProps.data.status) }}
							</template>
					</Column>
					<Column v-if="$route.params.status !== 'opened'" field="note" header="Reviewer note" :sortable="true">
							<template #body="slotProps">
									{{ slotProps.data.reviewer_note }}
							</template>
					</Column>
					<Column field="document" header="Document" :sortable="true" filterMatchMode="in">
            <template #body="slotProps">
							<Button class="btn-primary" label="Show" @click="openDocuments(slotProps.data.kyc_id, slotProps.data.email)"/>
						</template>
          </Column>
					<Column field="created_at" headerStyle="min-width: 80px" header="Created" :sortable="true">
						<template #body="slotProps">
								<span style="word-spacing: 80px; width: 80px;">{{ formatDate(slotProps.data.created_at) }}</span>
						</template>
				</Column>
				</DataTable>
			</div>
			
			<Dialog :header="title" :visible.sync="display" :style="{width: '50vw'}" :modal="true">
				<!-- <div v-for="(document) in documents" :key="document.kyc_id" class="card">
					<img :src="apiUrl + document.path" width="600">
				</div> -->
				<div class="content">
					<div class="content-documents">
						<h3>User documents</h3>
						<Carousel :value="documents" :numVisible="1" :circular="true">
							<template #item="slotProps">
								<div class="p-nogutter">
									<div class="image_holder">
										<a :href="apiUrl + slotProps.data.path" target="_blank">
											<img v-if="slotProps.data.mimetype.indexOf('image') !== -1" :src="apiUrl + slotProps.data.path" class="p-lg-12">
											<span v-else >{{apiUrl + slotProps.data.path}}</span>
										</a>
									</div>
								</div>
								<Button label="Rotate counterclockwise" icon="pi pi-undo" @click="rotateImage(slotProps.data.id, 'counterclockwise')"/>
								<Button label="Rotate clockwise" icon="pi pi-replay" @click="rotateImage(slotProps.data.id, 'clockwise')"/>
							</template>
						</Carousel>
					</div>
					<div class="content-data">
						<h3>User data</h3>
						<div class="data-item">
							<p>Client ID</p>
							<p>{{ activeRowUserData.id }}</p>
						</div>
						<div class="data-item">
							<p>Username</p>
							<p>{{ activeRowUserData.username }}</p>
						</div>
						<div class="data-item">
							<p>Name</p>
							<p>{{ activeRowUserData.name }}</p>
						</div>
						<div class="data-item">
							<p>Surname</p>
							<p>{{ activeRowUserData.surname }}</p>
						</div>
						<div class="data-item">
							<p>Date of birth</p>
							<p>{{ activeRowUserData.date_of_birth }}</p>
						</div>
						<div class="data-item">
							<p>Email</p>
							<p>{{ activeRowUserData.email }}</p>
						</div>
						<div class="data-item">
							<p>Address</p>
							<p>{{ activeRowUserData.address }}</p>
						</div>
						<div class="data-item">
							<p>City</p>
							<p>{{ activeRowUserData.city }}</p>
						</div>
						<div class="data-item">
							<p>Zip</p>
							<p>{{ activeRowUserData.zip }}</p>
						</div>
						<div class="data-item">
							<p>Country</p>
							<p>{{ activeRowUserData.country }}</p>
						</div>
					</div>
					<div class="content-review">
						<h3>Reviewer response</h3>
						<Textarea v-model="message" :autoResize="true" rows="3" cols="50"/>
					</div>
				</div>
				<template #footer>
					<div class="p-grid">
						<div class="p-md-6 p-offset-6">
							<Button v-if="$route.params.status !== 'approved'" label="Approve" @click="kyc_approve(activeRow)" icon="pi pi-check" class="p-button-success"/>
							<Button v-if="$route.params.status !== 'denied'" label="Deny" @click="kyc_deny(activeRow)" icon="pi pi-times" class="p-button-danger"/>
						</div>
					</div>
				</template>
			</Dialog>
		</div>
	</div>

</template>

<script>
import KycService from '../../service/KycService.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	data() {
		return {
            filters: {},
			dataTableKyc: null,
			dataTableSelectedKyc: null,
			layout: 'list',
			sortKey: null,
			sortOrder: null,
			sortField: null,
			display: false,
			activeRow: {},
			activeRowUserData: {},
			title: '',
			documents: [],
			apiUrl: process.env.VUE_APP_AUTH_URL,
			message: '',
			isLoading: false,
		}
	},
	components: {
		Loading
	},
	memberService: null,
	watch: {
		'$route.params.status': async function (status) {
			this.dataTableKyc = await this.kycService.getApplications(status)
		}
	},
	created() {
		this.$store.commit('setPageTitle', {pageTitle: 'KYC Applications'});
		this.kycService = new KycService();
		
	},
	async mounted() {
		this.$root.disableInterceptor()
		this.dataTableKyc = await this.kycService.getApplications(this.$route.params.status)
		this.$root.enableInterceptor()
	},
	methods: {
		async kyc_approve(kyc_id){
			await this.kycService.approveApplication(kyc_id, this.message);
			this.dataTableKyc = await this.kycService.getApplications(this.$route.params.status)
			this.close()
		},
		async kyc_deny(kyc_id){
			await this.kycService.denyApplication(kyc_id, this.message);
			this.dataTableKyc = await this.kycService.getApplications(this.$route.params.status)
			this.close()
		},
		onSortChange(event){
			const value = event.value.value;
			const sortValue = event.value;

			if (value.indexOf('!') === 0) {
				this.sortOrder = -1;
				this.sortField = value.substring(1, value.length);
				this.sortKey = sortValue;
			}
			else {
				this.sortOrder = 1;
				this.sortField = value;
				this.sortKey = sortValue;
			}
		},
		async openDocuments(kyc_id, email) {
			this.documents = []
			this.message = ''
			this.display = true;
			this.documents = await this.kycService.fetchDocuments(kyc_id);
			
			this.activeRow = kyc_id
			this.activeRowUserData = this.dataTableKyc.find(x => x.kyc_id === kyc_id)
			this.title = 'Uploaded documents for user: ' + email
		},
		async rotateImage(id, direction) {
			this.isLoading = true
			await this.kycService.rotateImage(id, direction);
			this.documents = []
			this.documents = await this.kycService.fetchDocuments(this.activeRow);
			this.documents[0].path = this.documents[0].path + '?timestamp=' + Date.now()
			this.dataTableKyc = await this.kycService.getApplications(this.$route.params.status)
			this.isLoading = false
		},
		open() {
			
		},
		close() {
			this.documents = []
			this.display = false;
		},
		formatDate(date, $hours=true) {
			if (date == null) return '';
			var d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear(),
				hours = "" + d.getHours(),
				mins = "" + d.getMinutes();

			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;
			if (hours.length < 2) hours = "0" + hours;
			if (mins.length < 2) mins = "0" + mins;

			if ($hours) return hours + ":" + mins + " " + [year, month, day].join("-");
			else return [day, month, year].join(".");
		},
		toUpperCase(string) {
			if (string === 'proof_of_address') {
				string = 'Address';
			}

			return string.toUpperCase();
		}
	}
}
</script>

<style lang="scss" scoped>
.p-column-filter {
    margin-top: .5em;
}
.image_holder {
	padding: 5px;
}
</style>